<form id="login" [formGroup]="loginForm" (submit)="login()">


    <div class="form-group">
        <label i18n>Email</label>
        <input type="email"
               id="login_email"
               name="user_email"
               class="form-control"
               formControlName="login_email"
               autocomplete="off"
               required=""

        >
        <div class="invalid-feedback">
            <div i18n>Email is required</div>
        </div>
    </div>

    <div class="form-group">
        <label i18n>Password</label>
        <input type="password"
               id="login_password"
               name="login_password"
               class="form-control"
               formControlName="login_password"
               autocomplete="off"
               required=""

        >
        <div class="invalid-feedback">
            <div i18n>Email is required</div>
        </div>
    </div>
    <div style="    padding-top: 10px;
    padding-bottom: 10px;min-height: 50px;">
        <div class="p-t-5 p-b-5" *ngIf="loginFailed" class="mat-error">
            {{errorMessage}}
        </div>
    </div>
    <div>
        <div class="pull-left">
            <a [routerLink]="'/user/password/reset'" i18n>Forgot password</a>
        </div>
        <div class="text-right mt-2 pull-right">

            <a id="save_new_user_btn" class="btn btn-success       "
               (click)="login()" style="width: 100px;"
               i18n="@@loginbtn"
            >
                <span style="width: 40px;">
                    <img src="assets/loader.gif" style="width: 20px !important;" *ngIf="isLoggingIn"/>
                    <i style="width: 20px " class="la la-arrow-right" *ngIf="!isLoggingIn"></i>
                </span >
                Login
            </a>

        </div>
    </div>

</form>
